/**
 * User-facing error messages paired with the codegen patterns in
 * `@models/autogen/v2.constraints` — co-located so every schema that wires
 * up a pattern check uses the same wording.
 */

export const NAME_PATTERN_MESSAGE =
  'Cannot contain control characters or angle brackets';

export const MULTILINE_TEXT_PATTERN_MESSAGE =
  'Cannot contain control characters';
